<template>
  <div>
      <headerNav title="奖品详情" />
      <div class="drawcards">
        <div class="drawcard" v-if="item">
          <div class="draw-content">
            <div class="drawcard-pic">
              <img :src="$baseurl + item.productPic" />
            </div>
            <div class="drawcard-wz">
              <div>{{ item.productName }}</div>
              <div>{{ item.drawTime }}</div>
            </div>
            <div class="drawcard-mm">
              <van-tag type="primary" v-if="!item.isUsed">未领取</van-tag>
              <van-tag type="danger" v-if="item.isUsed">已领取</van-tag>
            </div>
          </div>
        </div>
        
        <div v-if="item.drawLotteryEnum==0&&!item.isUsed">请选择您的收货地址</div>
        <div class="oo" v-if="item.drawLotteryEnum==0&&!item.isUsed">
        <div class="ooad" style="margin: 10px" v-if="addressData.receiverState">
          <div class="oo-left">
            <van-icon
              class="main-list-icon-right"
              :size="26"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="diqu"
            />
          </div>
          <div v-if="!addressData.receiverState" @click="gotoaddress">
            <div class="tit">暂无地址,点击前往添加地址</div>
          </div>
          <div v-else @click="gotoaddress">
            <div class="tit">
              {{ addressData.receiverName
              }}<span class="titphone" style="margin-right: 10px">{{
                addressData.receiverMobile
              }}</span>
              <van-tag type="primary" v-if="addressData.isAuthCard"
                >认证</van-tag
              >
              <van-tag type="danger" v-if="!addressData.isAuthCard"
                >未认证</van-tag
              >
            </div>
            <div class="stit">
              {{
                addressData.receiverState +
                addressData.receiverCity +
                addressData.receiverDistrict
              }}
            </div>
            <div class="stit">{{ addressData.receiverAddress }}</div>
          </div>
          <div class="oo-right">
            <van-icon
              class="main-list-icon-left"
              :size="14"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="you"
            />
          </div>
        </div>
      </div>
      
      </div>
      
      <div class="footerbtn" v-if="item.drawLotteryEnum==0&&!item.isUsed">
          <van-button style="width:80%" round :color="$abctheme.basecolor" :disabled="disabled" @click="gobuy()">去提货</van-button>
      </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      addressData: undefined,
      item: undefined,
      disabled:false,
    };
  },
  created() {
    this.item = JSON.parse(localStorage.getItem("drawlottery"));
    this.querydefault();
  },
  methods: {
    querydefault() {
      let id=localStorage.getItem('changeaddress') || 0;
      localStorage.setItem('changeaddress',''); 
      this.ajax
        .post("/api/services/app/PhoneUser/QueryDefaultAddress?id="+id)
        .then((x) => {
          this.addressData = x.result;
        });
    },
    gobuy()
    {
        this.addressData.winLotteryId=this.item.id;
        this.disabled=true;
        this.ajax.post('/api/services/app/PhoneDrawLottery/BuyGoods',this.addressData).then(x=>
        {
               this.$toast('创建成功');
        }).catch(x=>
        {
            this.disabled=false;
        })
    },
    gotoaddress() {
      this.$router.push({
        name: "address",
        params: {
          sourece: 1,
        },
      });
    },
  },
  activated() {
      //根据key名获取传递回来的参数，data就是map
      var vthis=this;
      this.$on(
        "changeaddress",
        function (data) {
          //console.log('返回触发数据:',data);
          //赋值给首页的附近医院数据模型
          console.log(data);
          vthis.addressData = data;
        }.bind(this)
      );
   },
};
</script>
<style lang="scss" scoped>
.drawcards {
  margin: 10px 20px;
  font-size: 14px;
}
.drawcard {
  padding: 10px;
  background-color: #fff;
  box-shadow: 1px 1px 3px #c3c3c3;
  border-radius: 4px;
}
.draw-content {
  position: relative;
  padding-left: 80px;
  min-height: 60px;
  line-height: 30px;
}
.drawcard-pic {
  position: absolute;
  left: 0;
  width: 60px;
  height: 60px;
  border-radius: 8px;
}
.drawcard-pic img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}
.drawcard-mm {
  position: absolute;
  right: 10px;
  top: 0;
}

.oo {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 1px 1px 3px #c3c3c3;
}

.ooad {
  position: relative;
  padding: 10px 50px 10px 50px;
}

.oo-left {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translate(0, -50%);
}

.oo-right {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translate(0, -50%);
}

.tit {
  font-size: 14px;
}

.titphone {
  margin-left: 10px;
  font-size: 12px;
  color: #ababab;
}

.oold {
  padding: 10px;
}

.oonj {
  position: relative;
  min-height: 90px;
  padding-left: 90px;
}

.oonj-img {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
  width: 80px;
  height: 80px;
}

.oonj-img img {
  width: 100%;
  height: auto;
  border-radius: 4px;
}

.oonj-info {
}

.oonj-info-tit {
  font-size: 14px;
  margin-bottom: 5px;
  width: calc(100% - 90px);
  word-break: break-all;
}

.oonj-info-tit .price {
  position: absolute;
  right: 0;
  top: 0;
}

.oonj-info-stitc {
  color: #b1b1b1;
  margin-bottom: 5px;
  font-size: 12px;
}

.oonj-info-stitc span:last-child {
  float: right;
}

.oonj-info-stit {
  color: #b1b1b1;
  margin-bottom: 5px;
  font-size: 12px;
}

.oomain {
}

.oomain-info {
  font-size: 13px;
  margin-bottom: 10px;
}

.oomain-info-dd {
  border-bottom: 1px solid #f5f5f5;
  padding: 10px 0;
  position: relative;
}

.ft {
  display: inline-block;
  width: 80px;
}

.ft-main {
  display: inline-block;
  width: calc(100% - 120px);
}

.ft-icon {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(0, -50%);
}

.oomain-info-dd input {
  width: calc(100% - 100px);
  border: 0;
}

.oomain-info-dd:last-child {
  border: 0;
}

.oofooter {
  text-align: right;
}

.oofooter .num {
  margin-right: 5px;
}

.oofooter .price {
  color: red;
}


.footerbtn{
    position: fixed;
    bottom: 0px;
    left:0;
    right:0;
    text-align: center;
    background-color: #fff;
    padding: 5px 0px;
}
</style>